export const CREATE_ENTRY_STRATEGY = 'CREATE_ENTRY_STRATEGY';
export const CREATE_ENTRY_STRATEGY_SUCCESSFUL = 'CREATE_ENTRY_STRATEGY_SUCCESSFUL';
export const CREATE_ENTRY_STRATEGY_FAILED = 'CREATE_ENTRY_STRATEGY_FAILED';
